var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenuAdmin"}},[_c('MenuAdmin',{attrs:{"id":"menuTop"}}),_c('div',{attrs:{"id":"main"}},[_c(_vm.layout,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }